// extracted by mini-css-extract-plugin
export default {"btn_header":"AnimatedBtnStyle_btn_header__ftiqE"};